module.exports = __webpack_public_path__ + "img/new_vote_bg.97c38ee7.png";